<template>
  <Layout>
    <PageHeader :title="title" :items="items"></PageHeader>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center mb-4">
              <div class="col-md-6">
                <div class="form-inline navbar-search">
                  <div class="input-group">
                    <input
                      class="form-control bg-light border-0 small"
                      placeholder="Search by group name..."
                      aria-label="Search by group name"
                      v-model="groupFilter"
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-search"
                        :disabled="!groupFilter"
                        @click="groupFilter = ''"
                      >
                        <i
                          :class="groupFilter ? 'fas fa-times fa-sm' : 'fas fa-search fa-sm'"
                        ></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 text-md-right">
                <span class="text-muted small">
                  {{ showingRange(filteredGroups, groupPage) }}
                  <template v-if="filteredGroups.length !== groups.length">
                    (filtered from {{ groups.length }})
                  </template>
                </span>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                striped
                bordered
                :items="pagedGroups"
                :fields="groupFields"
                responsive="sm"
                class="table-bordered table-hover"
                show-empty
                :empty-text="
                  groups.length
                    ? 'No groups match that name.'
                    : 'No groups with messages yet.'
                "
              >
                <template v-slot:cell(name)="row">
                  <span class="font-weight-bold">{{ row.item.name }}</span>
                </template>
                <template v-slot:cell(lastPreview)="row">
                  <span class="text-muted">{{ row.item.lastPreview || "—" }}</span>
                </template>
                <template v-slot:cell(lastAt)="row">
                  {{ formatTime(row.item.lastAt) }}
                </template>
                <template v-slot:cell(action)="row">
                  <router-link
                    :to="{
                      name: 'community-chat-thread',
                      params: { id: row.item.id },
                      query: { name: row.item.name },
                    }"
                    class="btn btn-sm btn-primary"
                  >
                    Open Chat
                  </router-link>
                </template>
              </b-table>
            </div>

            <div
              v-if="filteredGroups.length > perPage"
              class="d-flex flex-wrap align-items-center mt-3"
            >
              <b-form-select
                v-model="perPage"
                size="sm"
                style="max-width: 110px"
                :options="perPageOptions.map((n) => ({ value: n, text: n + ' / page' }))"
              ></b-form-select>
              <span class="text-muted small ml-2 mr-auto">
                {{ showingRange(filteredGroups, groupPage) }}
              </span>
              <b-pagination
                v-model="groupPage"
                :total-rows="filteredGroups.length"
                :per-page="perPage"
                size="sm"
                class="mb-0"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import MixinRequest from "@/mixins/request";
import communityChatMixin from "@/mixins/ModuleJs/community-chat";

export default {
  data() {
    return {
      title: "Community Chat",
      items: [
        { text: "Home", href: "/" },
        { text: "Groups" },
      ],
    };
  },
  mixins: [communityChatMixin, MixinRequest],
  components: {
    Layout,
    PageHeader,
  },
  created() {
    this.fetchGroups();
  },
};
</script>
